import React from "react"

import { Empty, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../Icon"
import Images from "../../Images"

import "./styles.less"

const { Title, Text } = Typography

const data = {
  alerts: {
    title: "No alerts found yet",
    text: "Currently, your account has no alerts",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  credits: {
    title: "No credits requests found yet",
    text: "Currently, your account has no credits requests",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  search: {
    title: "No results were found for your search",
    text: "Let's refine your search or try something different.",
    img: <Icon type="inbox_empty" style={{ fontSize: 32 }} />,
    imgHeight: 32
  },
  alerts_admin: {
    title: "No alerts found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  business_accounts_admin: {
    title: "No business accounts found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  users_admin: {
    title: "No users found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_enrollments_admin: {
    title: "No requests for new enrollments found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_billing_descriptors_admin: {
    title: "No requests for adding new billing descriptors found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_auto_refunds_admin: {
    title: "No requests for auto-refund adjustments found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_integrations_admin: {
    title: "No requests for adding new integrations found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_credits_admin: {
    title: "No requests for new credits found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  requests_verifi_inform_admin: {
    title: "No requests for verifi inform found",
    img: <Icon type="logo" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  no_data_available: {
    title: "No data available",
    disabled: true,
    img: <Icon type="no_data_available" style={{ fontSize: 40 }} />,
    imgHeight: 40
  },
  no_data_available_webhooks_endpoints: {
    title: "No endpoints available",
    text: "Your webhook endpoints will appear here. Create your first endpoint to start receiving events automatically.",
    img: <img src={Images.no_data_available_webhooks} alt="" width={325} height={124} />,
    imgDark: <img src={Images.no_data_available_webhooks_dark} alt="" width={325} height={124} />,
    imgHeight: 124
  },
  no_data_available_webhooks_events: {
    title: "No events available",
    text: "No events have been received yet. Webhook events will appear here once endpoint starts receiving requests from the API.",
    img: <img src={Images.no_data_available_webhooks} alt="" width={325} height={124} />,
    imgDark: <img src={Images.no_data_available_webhooks_dark} alt="" width={325} height={124} />,
    imgHeight: 124
  }
}
const EmptyComponent = ({ type, children, style, ...props }) => {
  const { t } = useTranslation()
  const theme = useSelector((state) => state.nav.theme)
  const { img, imgDark } = data[type] || {}
  return (
    <Empty
      className={`custom-empty custom-empty_${type}`}
      image={theme === "dark" ? imgDark || img : img}
      imageStyle={{ height: data[type]?.imgHeight || 0 }}
      style={style}
      description={
        <>
          <Title level={5} disabled={data[type]?.disabled}>
            {t(data[type]?.title)}
          </Title>
          <Text type={"secondary"}>{t(data[type]?.text)}</Text>
        </>
      }
    >
      {children}
    </Empty>
  )
}
export default EmptyComponent
